import React, { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';


function PromotedGallery({
  handleshow,
  companyName,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  company,
  handlesubmit,
  createdEdited
}) {
  const { preview, setPreview } = useContext(CreativeContext);
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [processingIndex, setProcessingIndex] = useState(-1);
  const [inputFields, setInputFields] = useState([
    {
      img_id: "",
      image: "",
    },
  ]);

  const imageChange = async (e, index) => {
    if (e.target.files && e.target.files.length > 0) {
      imageUrl(e.target.files[0], index);
      setProcessingIndex(index);
    } else {
      if (flag === "edit") {
        if (editdata.gallery[index]) {
          const values = [...inputFields];
          values[index].image = editdata.gallery[index].image;
          setInputFields(values);
          const { img_urls } = preview;
          img_urls[index] = editdata.gallery[index]?.image;
          setPreview(prev => ({ ...prev, img_urls: img_urls }));
        } else {
          setProgress(0);
          setValue(`image${index}`, "");
          const values = [...inputFields];
          values[index].image = "";
          setInputFields(values);
          const { img_urls } = preview;
          img_urls[index] = "";
          setPreview(prev => ({ ...prev, img_urls: img_urls }));
        }
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        const values = [...inputFields];
        values[index].image = "";
        setInputFields(values);
        const { img_urls } = preview;
        img_urls[index] = "";
        setPreview(prev => ({ ...prev, img_urls: img_urls }));
      }
    }
  };

  const imageUrl = async (imgFile, index) => {
    try {
      const formData = new FormData();
      formData.append("files", imgFile);
      let url = await api({
        url: `/upload/promotedimage`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
          setProgress(Math.round((100 * data.loaded) / data.total))
        },
      });
      if (url.code === 200) {
        let values = [...inputFields];
        values[index].image = url.data.data;
        setInputFields(values);
        const { img_urls } = preview;
        img_urls[index] = url.data.data;
        values[index].img_id = `${index}`;
        setPreview(prev => ({ ...prev, img_urls: img_urls }));
      } else {
        setProgress(0)
        setValue(`image${index}`, "");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  const handleAdd = () => {
    if (inputFields.length < 10) {
      setInputFields([
        ...inputFields,
        {
          image: "",
        },
      ]);
      const { img_urls } = preview;
      img_urls.push("");
    } else {
      Toast("error", "Maximum limit of 10 Images exceeded");
    }
  };

  const handleRemove = (index) => {
    setValue(`image${index}`, "");
    const values = [...inputFields];
    values.splice(index, 1);
    if (editdata.gallery && editdata.gallery[index]) {
      editdata.gallery.splice(index, 1);
    }
    setInputFields(values);
    const { img_urls } = preview;
    img_urls.splice(index, 1);
    setPreview(prev => ({ ...prev, img_urls: img_urls }));
  };

  const [startPosition, setStartPosition] = useState(-1);
  const [endPosition, setEndPosition] = useState(-1);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onTouched" });
  let watchTitle = watch("title");
  const watchmobileNum = watch('mobile')
  useEffect(() => {
    if (watchTitle !== "") {
      setPreview(prev => ({
        ...prev,
        head_line: watchTitle,
      }));
    } else {
      setPreview(prev => ({ ...prev, head_line: "" }));
    }
  }, [watchTitle]);

  let watchbtnurl = watch("btnurl", "");
  useEffect(() => {
    if (watchbtnurl !== "") {
      setPreview(prev => ({ ...prev, button_link: watchbtnurl }));
    } else {
      setPreview(prev => ({ ...prev, button_link: "" }));
    }
  }, [watchbtnurl]);

  let watchbtntext = watch("btntext", "");
  useEffect(() => {
    if (watchbtntext !== "") {
      setPreview(prev => ({ ...prev, button_text: watchbtntext }));
    } else {
      setPreview(prev => ({ ...prev, button_text: "" }));
    }
  }, [watchbtntext]);

  let watchlinkurl = watch("linkurl", "");
  let watchbtnclick = watch("btnclick", false);
  let watchdescription = watch("description", "");
  let watchphnclick = watch("phnclick");
  let watchbtnclikbutton = watch("btnclikbutton", false);
  let watchshuffle = watch('shuffle', false)
  let watchsubscription = watch('subscription')

  useEffect(() => {
    if (watchdescription !== "") {
      setPreview(prev =>  ({ ...prev, description: watchdescription }));
    } else {
      setPreview(prev => ({ ...prev, description: "" }));
    }
  }, [watchdescription]);

  let watchbuttonLang = watch("buttonLang");
  useEffect(() => {
    setPreview(prev => ({ ...prev, btn_text_lang: watchbuttonLang }));
  }, [watchbuttonLang]);

  useEffect(() => {
    if (watchbtnclikbutton !== false) {
      setPreview(prev => ({ ...prev, button_enabled: watchbtnclikbutton }));
    } else {
      setPreview(prev => ({ ...prev, button_enabled: false }));
    }
  }, [watchbtnclikbutton]);

  let watchbtntextclr = watch("btntextclr")
  useEffect(() => {

    if (watchbtntextclr !== "") {
      setPreview(prev => ({ ...prev, button_enabled: watchbtnclikbutton, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    } else {
      setPreview(prev =>({ ...prev, button_enabled: watchbtnclikbutton, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: '', btn_text_bgclr: watchbtntextbgclr }));
    }
  }, [watchbtntextclr]);

  let watchbtntextbgclr = watch("btntextbgclr")
  useEffect(() => {

    if (watchbtntextbgclr !== "") {
      setPreview(prev =>({ ...prev, button_enabled: watchbtnclikbutton, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    } else {
      setPreview(prev =>({ ...prev, button_enabled: watchbtnclikbutton, button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: '' }));
    }
  }, [watchbtntextbgclr]);

  if (flag === "edit") {
    watchbtnclick = watch(
      "btnclick",
      editdata.link_enabled === 0 ? false : true
    );
    watchphnclick = watch(
      "phnclick",
      watchdescription.search(/<<(0\d{10}|[6-9]\d{9})>>/) !== -1 ? true : false
    );
    watchsubscription = watch(
      "subscription",
      watchdescription.search(/<<(12)>>/) !== -1 ? true : false
    );
    watchbtnclikbutton = watch(
      "btnclikbutton",
      editdata.button_enabled === 0 ? false : true
    );

    watchshuffle = watch("shuffle", editdata.shuffle === 1 ? true : false)
  }
  const handletextchange = () => {
    if (startPosition === String(watchdescription).length || startPosition === endPosition) {
      Toast("error", "Please Select some text")
    }
    else if (startPosition >= 0 && endPosition > 0 && watchbtnclick && startPosition < watchdescription.length) {
      if (watchdescription.search("<<-1>>") && startPosition === 0) {
        const position = watchdescription.search("<<-1>>");
        if (position !== -1) {
          let text = watchdescription.substring(position);
          watchdescription = watchdescription.substring(0, position);
          text = text.replace("<<>>", "");
          text = text.replace("<<-1>>", "");
          watchdescription = watchdescription + text;
        }
        let pattern = `<<-1>>${watchdescription.substring(
          startPosition,
          endPosition
        )}<<>>`;
        watchdescription =
          watchdescription.substring(0, startPosition) +
          pattern +
          watchdescription.substring(endPosition);
        setValue("description", watchdescription);
        setStartPosition(0);
        setEndPosition(0);
      } else if (watchdescription.search("<<-1>>") !== -1) {
        const position = watchdescription.search("<<-1>>");
        let text = watchdescription.substring(position);
        if (position !== -1) {
          watchdescription = watchdescription.substring(0, position);
          text = text.replace("<<>>", "");
          text = text.replace("<<-1>>", "");
          watchdescription = watchdescription + text;
        }
        if (startPosition > position) {
          let pattern = `<<-1>>${watchdescription.substring(
            startPosition - 10,
            endPosition - 9
          )}<<>>`;
          watchdescription =
            watchdescription.substring(0, startPosition - 10) +
            pattern +
            watchdescription.substring(endPosition - 9);
          setValue("description", watchdescription);
          setStartPosition(0);
          setEndPosition(0);
        } else {
          let pattern = `<<-1>>${watchdescription.substring(
            startPosition,
            endPosition
          )}<<>>`;
          watchdescription =
            watchdescription.substring(0, startPosition) +
            pattern +
            watchdescription.substring(endPosition);
          setValue("description", watchdescription);
          setStartPosition(0);
          setEndPosition(0);
        }
      } else {
        let pattern = `<<-1>>${watchdescription.substring(
          startPosition,
          endPosition
        )}<<>>`;
        watchdescription =
          watchdescription.substring(0, startPosition) +
          pattern +
          watchdescription.substring(endPosition);
        setValue("description", watchdescription);
        setStartPosition(0);
        setEndPosition(0);
      }
    }
  };
  const handlePhone = () => {
    const watchmobile = watch("mobile");
    if (watchphnclick) {
      if (
        !errors.mobile &&
        watchmobile !== "" &&
        startPosition >= 0 &&
        endPosition > 0
      ) {
        let pattern = `<<${watchmobile}>>${watchdescription.substring(
          startPosition,
          endPosition
        )}<<>>`;
        watchdescription =
          watchdescription.substring(0, startPosition) +
          pattern +
          watchdescription.substring(endPosition);
        setValue("description", watchdescription);
        setStartPosition(0);
        setEndPosition(0);
        setValue("mobile", "");
      }
    }
  };
  const handleSubscription = () => {
    if(watchsubscription){
      if (
        startPosition >= 0 &&
        endPosition > 0
      ) {
        let pattern = `<<12>>${watchdescription.substring(
          startPosition,
          endPosition
        )}<<>>`;
        watchdescription =
          watchdescription.substring(0, startPosition) +
          pattern +
          watchdescription.substring(endPosition);
        setValue("description", watchdescription);
        setStartPosition(0);
        setEndPosition(0);
        setValue("mobile", "");
      }
      else{
        Toast('warning', "Please select some text!")
      }
    }
  };
  useEffect(()=>{
    if(watchsubscription) handleSubscription()
  },[watchsubscription])
  const resetdescription = () => {
    if (watchdescription.search("<<>>") !== -1) {
      if (watchbtnclick === false) {
        let text = watchdescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        let text_inside = watchdescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm)
        text_inside = String(text_inside)
        text_inside = text_inside.substring(6, text_inside.length - 4);
        if (text)
          watchdescription = watchdescription.replace(
           /<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm,
            text_inside
          );
        let newtext = watchdescription.match(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm)
        let linktext = watchdescription.match(/>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm)
        const originalString = String(linktext)
        const modifiedString = originalString.substring(2, originalString.length - 4);

        if (newtext) {
          watchdescription = watchdescription.replace(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm, modifiedString)
        }
      }

      if (watchphnclick === false) {
        let text = watchdescription.match(
          /(?<=<<[6-9]{1}[0-9]{9}>>)[a-zA-Z0-9!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (text) {
          for (let i of text) {
            watchdescription = watchdescription.replace(
              /<<(0\d{10}|[6-9]\d{9})>>[a-zA-Z0-9!@#$%^ &*(),.?'":{}|]+<<>>/i,
              i
            );
          }
        }
      }
      if(watchsubscription === false){
        let text = watchdescription.match(
          /(?<=<<12>>)[a-zA-Z0-9!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (text) {
          for (let i of text) {
            watchdescription = watchdescription.replace(
              /<<(12)>>[a-zA-Z0-9!@#$%^ &*(),.?'":{}|]+<<>>/i,
              i
            );
          }
        }
      }
      setValue("description", watchdescription);
    }
  };
  useEffect(() => {
    if (watchbtnclick === false) resetdescription();
    else if (watchphnclick === false) resetdescription();
  }, [watchbtnclick, watchphnclick, watchsubscription]);

  useEffect(() => {
    if (flag === "edit") {
      const data = JSON.parse(JSON.stringify(editdata.gallery));
      setInputFields(data);
      let img_urls = [];
      editdata.gallery.map((ele) => img_urls.push(ele.image));
      setPreview(prev => ({
        ...prev,
        img_urls: img_urls,
        sub_type: editdata.sub_type,
        head_line: editdata.head_line,
        description: editdata.description,
        button_enabled: editdata.button_enabled === 0 ? false : true,
        button_text: editdata.button_text,
        button_link: editdata.button_link === 0 ? false : true,
        btn_text_lang: editdata.btn_text_lang,
        btn_text_clr: editdata.btn_text_clr,
        btn_text_bgclr: editdata.btn_text_bgclr
      }));
    }
  }, [company]);

  const reset = (e) => {
    watchdescription = watchdescription.replace(/<<-1>>/g, "");
    watchdescription = watchdescription.replace(/<<>>/g, "");
    watchdescription = watchdescription.replace(/<<(0\d{10}|[6-9]\d{9})>>/g, "");
    setValue("description", watchdescription);
  };

  (watchbtnclick || watchphnclick || watchdescription) &&
    watchdescription &&
    document.querySelector("textarea").addEventListener("mouseup", (event) => {
      const selection = event.currentTarget;
      const start = selection.selectionStart;
      const end = selection.selectionEnd;
      setStartPosition(start);
      setEndPosition(end);
    });

  const onSubmit = async (data) => {
    if (inputFields.length < 2) {
      Toast("error", "Minimum 2 Images required");
    } else {
      if (flag === "add") {
        handlesubmit(true);
        let obj = {
          company_id: company,
          // adv_id: advId,
          company_name: companyName,
          creative_name,
          creative_type,
          sub_type: subtype,
          gallery: inputFields.map((obj1) => {
            return {
              img_id: parseInt(obj1.img_id),
              image: obj1.image,
            };
          }),
          title: data.title,
          description: data.description.includes("<<-1>>") ? data.description.replace("<<-1>>", `<<${data.linkurl}>>`) : data.description,
          impurl: { primary: data.impurl, secondary: data.impurl1 },
          btnclick: data.btnclick,
          btnclickbutton: data.btnclikbutton,
          linkurl: data.linkurl,
          btntext: data.btntext,
          btnurl: data.btnurl,
          shuffle: watchshuffle,
          btn_text_lang: parseInt(data.buttonLang),
          btn_text_clr: data.btntextclr,
          btn_text_bgclr: data.btntextbgclr
        };
        // if (advId !== "" && creative_name !== "") {
        if (creative_name !== "") {
          try {
            let res = await api({
              url: `/creatives/promoted/gallery`,
              method: "POST",
              responseType: "json",
              data: obj,
            });
            if (res?.code === 200) {
              Toast("success", " Creative Created Successfully  ");
              handleshow(false);
              createdEdited(true);
            } else {
              Toast("error", res.data.message);

            }
          } catch (error) {
            console.log(error);
            if (error.response.status === 401) navigate("/");
          }
        }
      } else if (flag === "edit") {
        let obj = {
          creative_id: editdata.creative_id,
          creative_name: creative_name,
          impurl: { primary: data.impurl, secondary: data.impurl1 },
          title: data.title,
          description: data.description.includes("<<-1>>") ? data.description.replace("<<-1>>", `<<${data.linkurl}>>`) : data.description,
          gallery: inputFields.map((obj1) => {
            return {
              img_id: parseInt(obj1.img_id),
              image: obj1.image,
            };
          }),
          shuffle: watchshuffle,
        };
        watchbtnclikbutton === true
          ? (obj.btnclickbutton = true)
          : (obj.btnclickbutton = false);
        watchbtnclikbutton === true
          ? (obj.btntext = data.btntext)
          : (obj.btntext = "");
        watchbtnclikbutton === true ? (obj.btn_text_clr = data.btntextclr) : (obj.btntextclr = "");
        watchbtnclikbutton === true ? (obj.btn_text_bgclr = data.btntextbgclr) : (obj.btntextbgclr = "");
        watchbtnclikbutton === true
          ? (obj.btnurl = data.btnurl)
          : (obj.btnurl = "");
        watchbtnclick === true ? (obj.btnclick = true) : (obj.btnclick = false);
        watchbtnclick === true
          ? (obj.linkurl = data.linkurl)
          : (obj.linkurl = "");
        watchbtnclikbutton === true
          ? (obj.btn_text_lang = parseInt(watchbuttonLang))
          : (obj.btn_text_lang = null);
        try {
          let res = await api({
            url: `/creatives/promoted/editgallery`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Edited Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);

          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    }
  };
  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)}>
          <section className="col-12">
            <div className="form-group">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Title"
                defaultValue={editdata.head_line}
                {...register("title", { required: true, maxLength: 75 })}
              />
              {errors.title?.type === "maxLength" && (
                <p className="text-red-600">
                  Title should be lessthan 75 characthers
                </p>
              )}
              {errors.title
                ? errors.title?.type !== "maxLength" && (
                  <p className="text-red-600">Title is mandatory</p>
                )
                : null}
              <br></br>
              <label className="form-label">Description <span className={`ml-24 d-flex justify-end font-bold ${flag === "edit" ? (`${400 - (watchdescription.length - (watchbtnclick ? String(watchlinkurl).length + 8 : watchdescription.search("<<>>") !== -1 ? 18 : 0))> 0 ? 'text-green-600' : 'text-red-600'}`): (`${400 - (watchdescription.length - (watchbtnclick ? 10 : watchphnclick ? 18 : 0))}` > 0 ? 'text-green-500' : 'text-red-500')}`}>
            {flag === "edit" ? (
  `${400 - (watchdescription.length - (watchbtnclick ? String(watchlinkurl).length + 8 : watchdescription.search("<<>>") !== -1 ? 18 : 0))} characters left`
) : (
  `${400 - (watchdescription.length - (watchbtnclick ? 10 : watchphnclick ? 18 : 0))} characters left`
)}
  </span></label>
              <textarea
                className="form-control"
                style={{backgroundColor:`${flag === "edit" ? (`${401 - (watchdescription.length - (watchbtnclick ? String(watchlinkurl).length + 8 : watchdescription.search("<<>>") !== -1 ? 18 : 0))> 0 ? 'fff' : 'rgb(254 242 242)'}`): (`${401 - (watchdescription.length - (watchbtnclick ? 10 : watchphnclick ? 18 : 0))}` > 0 ? '#fff' : 'rgb(254 242 242)')}`}}
                id="description"
                defaultValue={editdata.description}
                rows={4}
                {...register("description", { required: true, maxLength: flag === "add" ? 409 : 408 + String(watchlinkurl).length })}
              />
              {errors.description?.type === "maxLength" && (
                <p className="text-red-600">
                  Description should be lessthan 400 characthers
                </p>
              )}
              {errors.description
                ? errors.description?.type !== "maxLength" && (
                  <p className="text-red-600">Description is mandatory</p>
                )
                : null}
            </div>
          </section>

          <section>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={watchbtnclick}
                {...register("btnclick", { required: false })}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Enable Link
              </label>
            </div>

            {watchbtnclick && (
              <>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Link Url"
                    defaultValue={editdata.text_in_link}
                    {...register("linkurl", {
                      required: watchbtnclick,
                      pattern: {
                        value:
                        /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-warning"
                      onClick={handletextchange}
                      type="button"
                    >
                      Done
                    </button>
                  </div>
                </div>
                {errors.linkurl?.type === "pattern" && (
                  <p className="text-red-600">{errors.linkurl.message}</p>
                )}
                {errors.linkurl
                  ? errors.linkurl?.type !== "pattern" && (
                    <p className="text-red-600">{"Button URL Mandatory"}</p>
                  )
                  : null}
              </>
            )}
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={watchphnclick}
                {...register("phnclick", { required: false })}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Enable Phone Link
              </label>
            </div>

            {watchphnclick && (
              <>
                <div className="input-group">
                  <input
                    className="form-control"
                    placeholder="Enter Phone Number"
                    {...register("mobile", {
                      required: false,
                      maxLength: watchmobileNum ? (watchmobileNum[0] === "0" ? 11 : 10 ): 10,
                      pattern: { value: /(0\d{10}|[6-9]\d{9})/ },
                    })}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-warning"
                      onClick={handlePhone}
                      type="button"
                    >
                      Done
                    </button>
                  </div>
                </div>
                {errors.btnurl && (
                  <p className="text-red-600">{"Invalid Phone Number"}</p>
                )}
              </>
            )}
              <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={watchsubscription}
              {...register("subscription", { required: false})}
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              Enable Subscription Link
            </label>
          </div>
          </section>
          <section>
            <div>

              <div>
                {inputFields.map((inputField, index) => (
                  <>
                    <label className="form-label" key={`label${index}`}>
                      Image
                    </label><br />
                    <span>(Image width should be greater than height  )</span>
                    <div className="input-group mb-3" key={`img${index}`}>
                      <input
                        className="form-control "
                        type="file"
                        id="formFile"
                        name="files"
                        {...register(`image${index}`, {
                          required:
                            inputFields[index].image !== "" ? false : true,
                          onChange: (e) => imageChange(e, index),
                        })}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => handleRemove(index)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                    {errors[`image${index}`] && (
                      <p className="text-red-600">Image is mandatory</p>
                    )}
                    {processingIndex === index && progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar>
                      : inputFields[index].image !== "" ? (
                        <span>{`${inputField.image}`}</span>
                      ) : (
                        flag === "edit" && <span>{`${inputField.image}`}</span>
                      )}
                    <br></br>
                  </>
                ))}
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  name="add"
                  className="btn btn-primary"
                  onClick={() => handleAdd()}
                >
                  Add
                </button>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Impression URL - Primary</label>
                <input
                  type="text"
                  className="form-control"
                  name="impurl"
                  defaultValue={
                    editdata.impression_tracking_url
                      ? editdata.impression_tracking_url.primary
                      : null
                  }
                  {...register("impurl", {
                    required: false,
                    pattern: {
                      value:
                        /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                      message: "Enter a Valid URL",
                    },
                  })}
                />
                {errors.impurl && (
                  <p className="text-red-600">{errors.impurl.message}</p>
                )}
              </div>
              <div className="col">
                <label className="form-label">Impression URL - Secondary</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={
                    editdata.impression_tracking_url
                      ? editdata.impression_tracking_url.secondary
                      : null
                  }
                  {...register("impurl1", {
                    required: false,
                    pattern: {
                      value:
                        /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                      message: "Enter a Valid URL",
                    },
                  })}
                />
                {errors.impurl1 && (
                  <p className="text-red-600">{errors.impurl1.message}</p>
                )}
              </div>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={watchbtnclikbutton}
                {...register("btnclikbutton", { required: false })}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Enable Button Click
              </label>
            </div>
            {watchbtnclikbutton && (
              <>
                <div>(Button text Color and Back Ground color is mandatory)</div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Button Text</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.button_text}
                      {...register("btntext", { required: watchbtnclikbutton })}
                    />
                    {errors.btntext && (
                      <p className="text-red-600">Button Text is mandatory</p>
                    )}
                  </div>
                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text color
                    </label>
                    <input
                      type="color"
                      defaultValue={flag === "edit" ? editdata.btn_text_clr : "#000000"}
                      {...register("btntextclr", {
                        required: watchbtnclikbutton, pattern: {
                          value: /^#(?!000000)[a-zA-z0-9]{6}/gm
                        }
                      })}
                    />
                    {errors.btntextclr && (
                      <p className="text-red-600">Button Text color is mandatory</p>
                    )}
                  </div>

                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text background color
                    </label>
                    <input
                      type="color"
                      defaultValue={flag === "edit" ? editdata.btn_text_bgclr : "#ffffff"}
                      {...register("btntextbgclr", {
                        required: watchbtnclikbutton, pattern: {
                          value: /^#(?!ffffff)[a-zA-z0-9]{6}/gm
                        }
                      })}
                    />
                    {errors.btntextbgclr && (
                      <p className="text-red-600">Button Text background color  is mandatory</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">Button Link</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.button_link}
                      {...register("btnurl", {
                        required: watchbtnclikbutton,
                        pattern: {
                          value:
                        /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                          message: "Enter a Valid URL or Mobile Number",
                        },
                      })}
                    />
                    {errors.btnurl?.type === "pattern" && (
                      <p className="text-red-600">{errors.btnurl.message}</p>
                    )}
                    {errors.btnurl
                      ? errors.btnurl?.type !== "pattern" && (
                        <p className="text-red-600">{"Button URL Mandatory"}</p>
                      )
                      : null}
                  </div>
                  <div className="col">
                    <label className="form-label">Button Lang</label>
                    <select
                      className="form-select"
                      type="text"
                      defaultValue={
                        flag === "edit"
                          ? editdata.btn_text_lang !== null
                            ? `${editdata.btn_text_lang}`
                            : "1"
                          : "1"
                      }
                      {...register("buttonLang", { required: true })}

                    >
                      <option value="1">Telugu</option>
                      <option value="7">Bengali</option>
                      <option value="3">Hindi</option>
                      <option value="6">Marathi</option>
                      <option value="2">Tamil</option>
                      <option value="4">Kannada</option>
                      <option value="5">Malayalam</option>
                      <option value="8">Gujarathi</option>
                      <option value="10">Oria</option>
                      <option value="11">English</option>
                      <option value="13">Telugu-English</option>
                    </select>
                  </div>
                </div>
              </>)}
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={watchshuffle}
                {...register("shuffle", { required: false })}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                shuffle
              </label>
            </div>
            <div className="my-3 text-end">
              <button type="submit" className="btn btn-primary" disabled={(progress > 0 && progress < 100) ? true : false}>
                Save Creative
              </button>
            </div>
          </section>
        </form>
      </div>
    </>
  );
}

export default PromotedGallery;
